import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

export function BrandLogo({ compact = false }: { compact?: boolean }) {
  return (
    <img
      src="/logo-light.svg"
      width={compact ? 166 : 220}
      height={compact ? 36 : 48}
      alt="OnChainSage"
    />
  );
}

export function StatusPill({
  tone = "info",
  children
}: PropsWithChildren<{ tone?: "info" | "success" | "warning" | "danger" }>) {
  return <span className={`status-pill status-pill--${tone}`}>{children}</span>;
}

export function PrimaryButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button {...props} className={`primary-button ${props.className ?? ""}`} />;
}

export function SecondaryButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button {...props} className={`secondary-button ${props.className ?? ""}`} />;
}

export function Amount({ value, symbol = "USDT" }: { value: string; symbol?: string }) {
  const [whole, fraction = "000000"] = value.split(".");
  return (
    <span className="amount">
      <strong>{Number(whole || 0).toLocaleString("en-US")}</strong>
      <span>.{fraction.slice(0, 3)}</span>
      <small>{symbol}</small>
    </span>
  );
}
